import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-tracker',
  templateUrl: './progress-tracker.component.html',
  styleUrl: './progress-tracker.component.scss'
})
export class ProgressTrackerComponent{
  @Input() steps: { label: string; state: 'default' | 'active' | 'completed' }[] = [];
  @Input() scale: number = 1;

  @HostListener('window:resize', [])
  getTransformOrigin(): string {
    const screenWidth = window.innerWidth;
  
    if (screenWidth < 450) {
      return "left";
    } else if (screenWidth >= 450 && screenWidth <= 1024) {
      return "center";
    } else {
      return "top left";
    }
  }

  get filteredSteps() {
    const currentStepIndex = this.steps.findIndex(step => step.state === 'active');
    const lastStepIndex = this.steps.length - 1;
  
    return this.steps.filter((_, index) => {
      if (currentStepIndex === 0) {
        // If it's the first step, show step 0, step +1, and step +2
        return index === currentStepIndex || index === currentStepIndex + 1 || index === currentStepIndex + 2;
      }
  
      if (currentStepIndex === lastStepIndex) {
        // If it's the last step, show step -2, step -1, and current step
        return index === currentStepIndex || index === currentStepIndex - 1 || index === currentStepIndex - 2;
      }
  
      // Default behavior: Show previous, current, and next steps
      return index === currentStepIndex || index === currentStepIndex - 1 || index === currentStepIndex + 1;
    });
  }


}
